import { ImgSelect } from 'imaginarity-react-ui';
import _ from 'lodash';
import * as React from 'react';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';

export interface EditSelectProps<T, TP> {
    getter: (value: T) => TP | undefined;
    options: any[];
    getOptionLabel?: (option: any) => string;
    comparer?: (v1: TP | undefined, v2: TP | undefined) => boolean;
}

const EditSelect = <T extends BaseEditItem = BaseEditItem, TP = string>(props: EditSelectProps<T, TP>) => {
    const { options, getOptionLabel, getter, comparer } = props;
    const { value: val, setValue: setVal } = useGPEState(getter);
    const onChange = React.useCallback((newValue: any) => {
        setVal(newValue.value ?? newValue);
    }, [setVal]);
    const selectedValue = React.useMemo(() => {
        const sel = _.find(options, o => comparer ? comparer(o, val) : o === val || o?.value === val);
        return sel;
    },
        [val, comparer, options]);
    return (
        <div>
            <ImgSelect
                options={options}
                getOptionLabel={getOptionLabel}
                value={selectedValue}
                onChange={onChange}
            />
        </div>
    );
}

export default EditSelect;
